import Login from "../../views/Auth/Login.vue";
import Forgot from "../../views/Auth/Forgot.vue";

export default [
  {
    path: "/auth/login",
    name: "login",
    component: Login
  },
  {
    path: "/auth/forgot",
    name: "forgot",
    component: Forgot
  }
];
